window.addEventListener('load', () => {
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');

    hamburger.addEventListener('click', e => {
        e.preventDefault();

        if (hamburger.classList.contains('active')) {
            hamburger.classList.remove('active');
            mobileMenu.classList.remove('open');
            mobileMenuOverlay.classList.remove('visible');

            return;
        }

        hamburger.classList.add('active');
        mobileMenu.classList.add('open');
        mobileMenuOverlay.classList.add('visible');
    });

    mobileMenuOverlay.addEventListener('click', () => {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('open');
        mobileMenuOverlay.classList.remove('visible');
    });
});
